import React from "react";
import styles from "../style/style";
import { IoCloseCircle } from "react-icons/io5";

function DeletePoPup({
  setIsDelteClientOpen,
  isDelteClientOpen,
  content,
  handleDelete,
}) {
  return (
    <div>
      <div className={`${styles.model}`}>
        <div className={`${styles.model1} h-screen`}>
          <div className="w-full bg-white  rounded-3xl   sm:max-w-md  ">
            <div className="relative p-6 space-y-4 md:space-y-6 sm:p-8">
              <div
                className={`${styles.closeX}`}
                onClick={() => setIsDelteClientOpen(!isDelteClientOpen)}
              >
                <IoCloseCircle className="text-2xl"/>
              </div>
              <div className="p-6 text-center text-thirdColor">
                <svg
                  aria-hidden="true"
                  className="mx-auto mb-4  w-14 h-14 "
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  ></path>
                </svg>

                <h3 className="mb-5 text-lg font-normal ">
                  Are you sure you want to delete {content}?
                </h3>
                <div className="flex sm:flex-row flex-col items-center justify-center gap-3 sm:gap-5">
                  <button
                    onClick={() => handleDelete()}
                    type="button"
                    className=" bg-red-600 text-white   outline-none  font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center mr-2"
                  >
                    Yes, I'm sure
                  </button>
                  <button
                    onClick={() => setIsDelteClientOpen(!isDelteClientOpen)}
                    type="button"
                    className=" outline-none  rounded-lg text-sm font-medium px-5 py-2.5  bg-gray-700 text-white "
                  >
                    No, cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DeletePoPup;
